<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <div class="formControl mt">
            <pr-input-radio
              formControlName="userMaritalSituation"
              direction="column"
              [isDefault]="false"
              columns="3"
              [options]="options"
            >
            </pr-input-radio>
            @if (reference$ | async; as reference) {
              <pr-input-column
                label="Quel régime matrimonial avez-vous choisi ?"
                [derrors]="derrors"
                [hidden]="
                  ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                    owner.get('userMaritalSituation').value
                  )
                "
              >
                <mat-select formControlName="marriageRegime">
                  @for (
                    regime of selectedMarriageRegime(reference);
                    track regime
                  ) {
                    <mat-option [value]="regime.id">
                      {{ regime.value | translate }}
                    </mat-option>
                  }
                </mat-select>
              </pr-input-column>
            }
            <div class="row">
              <div class="col-md-6 mt">
                <pr-input-radio
                  formControlName="unionContract"
                  columns="3"
                  [toggle]="true"
                  label="Mariage/Pacs avec contrat ?"
                  [hidden]="
                    ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                      owner.get('userMaritalSituation').value
                    )
                  "
                >
                </pr-input-radio>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <pr-input-date
                  label="Date de mariage/pacs"
                  formControlName="unionDate"
                  [derrors]="derrors"
                  [isDefault]="false"
                  [hidden]="
                    ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                      owner.get('userMaritalSituation').value
                    )
                  "
                ></pr-input-date>
              </div>
              <div class="col-md-6">
                <pr-input-column
                  label="Lieu du mariage/pacs"
                  [derrors]="derrors"
                  [hidden]="
                    ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                      owner.get('userMaritalSituation').value
                    )
                  "
                >
                  <input formControlName="unionPlace" type="text" />
                </pr-input-column>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <pr-input-column
                  label="Prénom du conjoint/de la conjointe"
                  [derrors]="derrors"
                  [hidden]="
                    ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                      owner.get('userMaritalSituation').value
                    )
                  "
                >
                  <input formControlName="userSpouseFirstName" type="text" />
                </pr-input-column>
              </div>
              <div class="col-md-6">
                <pr-input-column
                  label="Nom du conjoint/de la conjointe"
                  [derrors]="derrors"
                  [hidden]="
                    ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                      owner.get('userMaritalSituation').value
                    )
                  "
                >
                  <input formControlName="userSpouseLastName" type="text" />
                </pr-input-column>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <pr-input-column
                  label="Nom de naissance du conjoint/de la conjointe"
                  [derrors]="derrors"
                  [hidden]="
                    ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
                      owner.get('userMaritalSituation').value
                    )
                  "
                >
                  <input formControlName="userSpouseBirthName" type="text" />
                </pr-input-column>
              </div>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
